import React, { useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import HTMLFlipBook from 'react-pageflip';

function Newsletter2() {

    const { state } = useLocation();
    const navigate = useNavigate();
    const flipBookRef = useRef();
    const newsletter = state?.newsletter;
    const goToNextPage = () => {
        if (flipBookRef.current) {
            flipBookRef.current.pageFlip().flipNext(); // Call flipNext method
        }
    };

    const goToPreviousPage = () => {
        if (flipBookRef.current) {
            flipBookRef.current.pageFlip().flipPrev(); // Call flipPrev method
        }
    };
    if (!newsletter) {
        return (
            <div className="container mt-5">
                <p>No newsletter selected. <button onClick={() => navigate(-1)}>Go Back</button></p>
            </div>
        );
    }
    return (
        <>

            <div className="container">
                {newsletter === "news1" && (
                    <div className="row inner-content">
                        <div className="col-md-12">
                            <div className="flipOpen">
                                <HTMLFlipBook ref={flipBookRef} width={600} height={800} minWidth={315} maxWidth={1000} minHeight={400} mobileScrollSupport={true} showCover={true} useMouseEvents={true} className="flipPageComponent" pageBackground="rgb(255, 255, 255)" uncutPages={true} >
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-1.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-2.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-3.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-4.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-5.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-6.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-7.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-8.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-9.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-10.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-11.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-12.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-13.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-14.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-15.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-16.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-17.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-18.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-19.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-20.jpg" alt="Page 1" /></div>
                                    <div><img src="https://webapi.entab.info/api/image/NCSR/public/Images/newsletter/newsletter2-21.jpg" alt="Page 1" /></div>



                                </HTMLFlipBook>
                            </div>
                            <div className="navigation-buttons">
                                <button onClick={goToPreviousPage} className="btn btn-primary">
                                    <i class="bi bi-arrow-left"></i>
                                </button>
                                <button onClick={goToNextPage} className="btn btn-primary">
                                    <i class="bi bi-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </>
    )
}

export default Newsletter2